import Typography from '@/common/components/base/typography/Typography';
import ArrowDownIcon from '@/modules/Education/assets/icons/arrow-down.svg?react';
import CloseIcon from '@/modules/Education/assets/icons/close-circle.svg?react';
import { Box, Flex } from 'styled-system/jsx';
import { EducationFilterProps } from '../../types/Education.type';

export const EducationFilter = ({
  hasSelection,
  selectionText,
  onClear,
  onClick,
}: EducationFilterProps) => {
  return (
    <Flex
      width="fit-content"
      alignItems="center"
      border="1px solid"
      borderColor={hasSelection ? 'purple-2' : 'black-3'}
      bg={hasSelection ? 'purple-6' : 'gray-4'}
      gap={4}
      padding="4px 8px"
      borderRadius="rounded"
    >
      {hasSelection && (
        <Flex
          alignItems="center"
          cursor="pointer"
          ml={4}
          onClick={(e) => {
            e.stopPropagation();
            onClear();
          }}
        >
          <CloseIcon />
        </Flex>
      )}

      <Typography
        color={hasSelection ? 'purple-1' : 'black-2'}
        onClick={onClick}
        textStyle="b2"
        cursor="pointer"
      >
        دسته بندی
      </Typography>

      {hasSelection && (
        <Flex alignItems="center" cursor="pointer" gap={4} onClick={onClick}>
          <Box width="2px" height="15px" bg="purple-4" mx={2} />
          <Typography color="black-1" textStyle="b2">
            {selectionText}
          </Typography>
        </Flex>
      )}

      <Box onClick={onClick} cursor="pointer">
        <ArrowDownIcon />
      </Box>
    </Flex>
  );
};
